import styled from '@emotion/styled';
import { Box, Divider, Grid, Typography } from '@mui/material';
import Header from 'components/Common/Header';
import DetailItem from 'components/Staff/ItemDetail';
import Button from 'components/Common/Button';
import AssistanceFooter from 'components/Common/AssistanceFooter';
import ProfileContainer from 'components/Account/ProfileContainer';
import { useNavigate } from 'react-router-dom';
import routes from 'constants/routes';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { getAddress } from 'utils/helpers';
import { selectEffectiveStaffRole, selectHasPortalStaffAccess } from 'redux/selectors/parishContext';

const Container = styled('div')({
    backgroundColor: '#F2F2F6',
    padding: '20px',
    minHeight: '100vh',
});

const InnerContainer = styled('div')({
    backgroundColor: 'white',
    marginBottom: 52,
});

function MyAccount() {
    const navigate = useNavigate();
    const { user, hasStaffAccess, effectiveRole, selectedParishName } = useSelector((state: RootState) => ({
        user: state.user,
        hasStaffAccess: selectHasPortalStaffAccess(state),
        effectiveRole: selectEffectiveStaffRole(state),
        selectedParishName: state.user.selectedParishName,
    }));
    const { userInfo, address } = user || {};
    const { name, email, username, imgUrl, telephone, status } = userInfo || {};
    const { city = '', state = '', zipCode = '' } = address || {};
    const roleLabel = effectiveRole ? effectiveRole.replace(/_/g, ' ') : hasStaffAccess ? 'Staff' : 'Member';

    return (
        <Container>
            <Header />
            <div style={{ backgroundColor: 'white', alignItems: 'center', marginTop: 42 }}>
                <Typography sx={{ p: 2, marginLeft: 2 }} variant="h6">
                    Account Details
                </Typography>
                <Divider />
            </div>

            <InnerContainer>
                <Box sx={{ padding: '1rem' }}>
                    <Box sx={{ ml: 10, mr: 10 }}>
                        <Box>
                            <ProfileContainer
                                isEmployee={!hasStaffAccess}
                                showEditIcon
                                status={status}
                                name={name}
                                email={username}
                                imageUrl={imgUrl}
                            />
                            <Divider />
                        </Box>
                        <Grid sx={{ my: 3 }} container spacing={2} justifyContent={'space-between'}>
                            <Grid item xs={12} md={6}>
                                <DetailItem label="Name" value={name || ''} />
                                <DetailItem label="Email/user name" value={email || ''} />
                                <DetailItem label="Parish Name" value={selectedParishName || ''} />
                                <DetailItem label="Phone" value={telephone ? String(telephone) : ''} />
                                <DetailItem label="Role" value={roleLabel} />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <DetailItem label="Address" value={getAddress(address)} />
                                <DetailItem label="City" value={city} />
                                <DetailItem label="State" value={state} />
                                <DetailItem label="Zip" value={zipCode} />
                            </Grid>
                        </Grid>
                        <div
                            style={{
                                marginTop: 74,
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                flexDirection: 'column',
                            }}
                        >
                            <Button
                                onClick={() => navigate(routes.account.changePassword)}
                                sx={{ width: { xs: '90%', sm: '40%' } }}
                                title="Change Password"
                            />
                            <div style={{ width: '100%' }}>
                                <AssistanceFooter />
                            </div>
                        </div>
                    </Box>
                </Box>
            </InnerContainer>
        </Container>
    );
}

export default MyAccount;
